import { Component, OnInit } from '@angular/core';
import {  Router } from '@angular/router';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { CancelOrderService } from '../../../../../app/features/cancel-order/services/cancel-order.service';
import { ToasterService } from "../../../../common/services/toaster.service";
@Component({
    selector: 'app-custom-reports-report-page',
    templateUrl: 'custom-reports.page.html',
    styleUrls: [
      './custom-reports.page.scss',
    ]
})
export class CustomReportPage implements OnInit {
   webReport:any;
   cancelReport:any;
   returnReview:any;
    constructor(
      private router: Router,
      private toasterService: ToasterService,
      private cancelOrderService: CancelOrderService,
      public authService: GtrakAuthService
    ) { }


    loading: boolean = true;

    async ngOnInit() {
      var userId=this.authService.user.id.toString();
        const response= await this.cancelOrderService.getWebReport(userId);
         this.webReport=response?.result;
         for(let i=0; i<this.webReport.length; i++){
            if(this.webReport[i].id==9){
                  this.cancelReport=this.webReport[i];
            }
                if(this.webReport[i].id==10){
                  this.returnReview=this.webReport[i];
            }
         }
    }

    async viewCustomerReports(report) {
    this.loading=false;
    
    if (!report.apP_TARGET) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Please add link or query in web_reports table."
      );
      this.loading=true;
      return false;
    }

    const target = report.apP_TARGET.toLowerCase();

    if (report.reportType === 'link' && target.includes('select ')) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Invalid target: expected a link, but found a query."
      );
      this.loading=true;
      return false;
    }

    if (report.reportType === 'query'  && !target.includes('select ')) {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Invalid target: expected a query, but not found."
      );
      this.loading=true;
      return false;
    }

    if (report.reportType === 'link') {
      if(report.apP_TARGET!=null){
        if(report.id==10){
          this.router.navigate([`admin-page/customer-site-reports/${report.apP_TARGET}`]);
        }
        else{
              this.router.navigate([`custom-reports/${report.apP_TARGET}`]);
        }
      }
      else{
         this.toasterService.presentToast(
        "danger",
        "Error",
        "Please check web_reports table."
      );
      this.loading=true;
      return false;
      }
    } 
    else if (report.reportType === 'query') {
      this.router.navigate([`admin-page/customer-site-reports/query-view/${report.id}`]);
    } 
    else {
      this.toasterService.presentToast(
        "danger",
        "Error",
        "Please check web_reports table."
      );
      this.loading=true;
      return false;
    }
        this.loading=true;
  }

}